import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import React, { useEffect } from 'react';

import { SectionCardWrapper, StickyListWrapper, SectionWrapper } from './styled';
import { toggleActiveModal } from '../../shared/layout/reducers';
import { PageWrapper } from '../../shared/layout/styled';
import PageIntro from '../../shared/layout/page-intro';
import Footnote from '../../shared/layout/footnote';
import { setPreviewedFeature } from '../reducers';
import { features } from '../ui-data';

const Features = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const switchFeature = (subFeatureId) => history.push({ pathname: `/features/${subFeatureId}` });

  const previewFeature = ({ subFeatureIndex, featureIndex }) => {
    dispatch(setPreviewedFeature({ subFeatureIndex, featureIndex }));
    dispatch(toggleActiveModal('featurePreview'));
  };

  const scrollToFeature = (featureId) => {
    document.querySelector(`#${featureId}`)
    .scrollIntoView({
      behavior: 'smooth',
      inline: 'start'
    });
  };

  useEffect(() => {
    const subFeatureId = location.pathname.split('/').filter((path) => path)[1];
    const featureId = location.hash.replace('#', '');
    
    if (subFeatureId) {
      const previewPayload = features.reduce((payload, feature, featureIndex) => {
        const subFeatureIndex = feature.subFeatures.reduce((subFeatureIndex, subFeature, index) => {
          if (subFeature.id === subFeatureId) subFeatureIndex = index;
          return subFeatureIndex;
        }, undefined);

        if (subFeatureIndex >= 0) payload = { subFeatureIndex, featureIndex, feature };
        return payload;
      }, null);

      if (previewPayload) {
        scrollToFeature(previewPayload.feature.id);
        previewFeature(previewPayload);
      }
    } else if (featureId) scrollToFeature(featureId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <PageWrapper id="features-page">
      <PageIntro />

      <div className="container with-sticky-list">
        <div className="main">
          {features.map((feature) => (
            <SectionWrapper key={feature.id} id={feature.id}>
              <div className="intro" style={{ '--section-image': `url(${feature.image})` }}>
                <h2>{feature.title}</h2>
                <p>{feature.description}</p>
              </div>

              <div className="sub-features">
                {feature.subFeatures.map((subFeature, subFeatureIndex) => (
                  <SectionCardWrapper
                    onClick={() => switchFeature(subFeature.id)}
                    key={subFeature.title}
                  >
                    <div className="icon">
                      <img src={subFeature.icon} alt="feature-icon" />
                    </div>

                    <h3>{subFeature.title}</h3>
                    <p>{subFeature.description}</p>
                  </SectionCardWrapper>
                ))}
              </div>
            </SectionWrapper>
          ))}
        </div>

        <StickyListWrapper>
          {features.map(({ subFeatures, name, id }) => (
            <li key={name}>
              <button
                title={`${subFeatures.length} ${name} features`}
                onClick={() => scrollToFeature(id)}
                type="button"
              >
                {name}
              </button>
              <span>{subFeatures.length}</span>
            </li>
          ))}
        </StickyListWrapper>
      </div>

      <Footnote />
    </PageWrapper>
  );
};

export default Features;